<bms-common-popup
  [icon]="data.icon || 'description'"
  [title]="data.title"
  [subTitle]="data.subtitle"
  [cancelTitle]="'shared.remarks-popup.cancel' | translate"
  [submitTitle]="'shared.remarks-popup.save' | translate"
  (onCancelClick)="onCancel()"
  (onSubmitClick)="onSave()"
  [isSubmitEnabled]="isSaveEnabled"
>
  <form [formGroup]="uploadForm" class="form-container">
    <mat-form-field
      appearance="fill"
      class="w-100"
      *ngIf="uploadForm.controls.remarks.enabled"
    >
      <mat-label>Remarks</mat-label>
      <input
        matInput
        data-testid="remarks_document_upload"
        formControlName="remarks"
        placeholder="Re upload document with remarks"
      />
      <mat-error *ngIf="uploadForm.controls.remarks.hasError('required')">
        Remarks is required
      </mat-error>
    </mat-form-field>

    <div class="row mb-3" *ngIf="data.isReceivedQuotationFlow">
      <div class="col-sm-12">
        <mat-checkbox formControlName="isPackageWise">
          Quotation Package Wise
        </mat-checkbox>
      </div>
    </div>

    <ng-container *ngIf="!uploadForm.controls.isPackageWise?.value">
      <mat-form-field appearance="fill" class="w-100">
        <mat-label>{{ fieldName }}</mat-label>
        <input
          matInput
          data-testid="quotation_number_document_upload"
          formControlName="quotationNumber"
          placeholder="Q9812340"
        />
        <mat-error
          *ngIf="
            uploadForm.controls.quotationNumber.hasError('required') ||
            uploadForm.controls.quotationNumber.hasError('whitespace')
          "
        >
          {{ fieldName }} is required
        </mat-error>
      </mat-form-field>

      <div class="drag-drop-container">
        <app-drag-and-drop
          [disableField]="!uploadForm.controls.quotationNumber.value"
          [allowUpload]="true"
          [allowDelete]="true"
          [uploadDirectly]="false"
          [displayImg]="true"
          (triggerFileSelected)="triggerFileSelected($event)"
          [showUploadedFiles]="false"
          [allowedTypesNames]="data?.allowedTypesNames"
          [allowedTypesRegex]="data?.allowedTypesRegex"
          [maxSize]="data?.maxSize"
          [remainingFilesCount]="fileCount"
          [remainingFiles]="true"
          required
        >
        </app-drag-and-drop>

        <app-display-data-in-dlt
          *ngIf="documentsDataList?.length > 0"
          [dataListArray]="documentsDataList"
          (onClickAction)="action($event)"
        >
        </app-display-data-in-dlt>
      </div>
    </ng-container>

    <div
      class="packages-section mt-3"
      *ngIf="uploadForm.controls.isPackageWise?.value"
    >
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h3 class="m-0 font-weight-bold" style="font-size: 16px">
          Packages List
        </h3>
        <button
          type="button"
          mat-raised-button
          color="primary"
          (click)="addPackage()"
        >
          <mat-icon>add</mat-icon> Add Package
        </button>
      </div>

      <div class="packages-list">
        <div
          *ngFor="let pkg of packages.controls; let i = index"
          [formGroup]="$any(pkg)"
          class="package-item p-3 mb-3 border rounded position-relative"
          style="
            background: #fdfdfd;
            border: 1px solid #e0e0e0;
            border-radius: 8px;
          "
        >
          <div class="row align-items-center">
            <div class="col-md-4">
              <mat-form-field appearance="fill" class="w-100 mb-0">
                <mat-label>Package Name</mat-label>
                <input
                  matInput
                  formControlName="packageName"
                  placeholder="e.g. Package Premium"
                />
                <mat-error
                  *ngIf="
                    pkg.get('packageName')?.hasError('required') ||
                    pkg.get('packageName')?.hasError('whitespace')
                  "
                >
                  Package Name is required
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-md-4">
              <mat-form-field appearance="fill" class="w-100 mb-0">
                <mat-label>Quotation Number</mat-label>
                <input
                  matInput
                  formControlName="quotationNumber"
                  placeholder="e.g. Q12345"
                />
                <mat-error
                  *ngIf="
                    pkg.get('quotationNumber')?.hasError('required') ||
                    pkg.get('quotationNumber')?.hasError('whitespace')
                  "
                >
                  Quotation Number is required
                </mat-error>
              </mat-form-field>
            </div>

            <div
              class="col-md-3 d-flex align-items-center justify-content-center"
            >
              <input
                type="file"
                #fileInput
                style="display: none"
                (change)="onPackageFileSelected($event, i)"
                [accept]="
                  data.allowedTypesNames
                    ? '.pdf,.docx,.jpeg,.jpg,.png,.csv'
                    : '*'
                "
              />
              <button
                type="button"
                mat-stroked-button
                color="primary"
                (click)="fileInput.click()"
                *ngIf="!pkg.get('file')?.value"
                style="height: 48px"
                class="w-100"
              >
                <mat-icon>upload</mat-icon> Upload Doc
              </button>

              <div
                *ngIf="pkg.get('file')?.value"
                class="d-flex align-items-center justify-content-between w-100 px-2"
              >
                <div
                  class="d-flex align-items-center text-truncate"
                  style="max-width: 80%"
                >
                  <mat-icon class="mr-1 text-success"
                    >insert_drive_file</mat-icon
                  >
                  <span
                    class="file-name text-truncate"
                    [title]="pkg.get('file')?.value?.name"
                  >
                    {{ pkg.get('file')?.value?.name }}
                  </span>
                </div>
                <button
                  type="button"
                  mat-icon-button
                  color="warn"
                  (click)="removePackageFile(i)"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>

            <div class="col-md-1 text-right">
              <button
                type="button"
                mat-icon-button
                color="warn"
                (click)="removePackage(i)"
                *ngIf="packages.length > 1"
              >
                <mat-icon>delete_forever</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</bms-common-popup>
